import React, { memo } from 'react';

import type { OptionsEditorPopoverProps } from './types';
import { NumberOptionsEditorPopover } from './NumberOptionsEditorPopover';
import { TextOptionsEditorPopover } from './TextOptionsEditorPopover';

function OptionsEditorPopover(props: OptionsEditorPopoverProps) {
  return props.kind === 'text' ? (
    <TextOptionsEditorPopover {...props} />
  ) : (
    <NumberOptionsEditorPopover {...props} />
  );
}

export default memo(OptionsEditorPopover);
